export const confirmResultUiSchema = {
  'ui:order': ['conclusion', '*'],
  conclusion: {
    'ui:widget': 'radio',
    'ui:stacked': true
  }
}
